<template>
  <LinkCss :href="getWithHost(tailwindCss)" v-model:on-load-end="show" />

  <body v-if="show" class="relative mt-6">
    <div class="mb-6">
      <ProductImagesMobileCe
        @event:image-clicked="emit('event:imageClicked', $event)"
        :items="props.bookInfo.images"
      >
      </ProductImagesMobileCe>
    </div>
    <div class="mb-6">
      <div class="text-xl font-bold">
        {{ props.bookInfo.name }}
      </div>
    </div>
    <div class="mb-6">
      <div class="rounded-md bg-stone-100 p-5">
        <ProductPrice :item="props.bookInfo" :version="'mobile'"></ProductPrice>
      </div>
    </div>
    <div class="mb-6" v-if="props.bookInfo.select_data">
      <ProductSelect :select-data="props.bookInfo.select_data"></ProductSelect>
    </div>
    <div class="mb-8" v-if="(props.bookInfo.characteristic?.length ?? 0) > 0">
      <ProductCharacteristicMobileCe
        :items="props.bookInfo.characteristic ?? []"
      ></ProductCharacteristicMobileCe>
    </div>
    <div class="mb-6">
      <div class="mb-5 text-xl font-semibold">О товаре</div>
      <div>
        <slot></slot>
      </div>
    </div>
    <div class="sticky bottom-0 left-0">
      <div>
        <ProductButton
          :product-id="props.bookInfo.id"
          @open-basket="emit('open-basket', props.bookInfo)"
          @to-basket="emit('to-basket', props.bookInfo)"
        ></ProductButton>
        <div class="h-4 blur-sm"></div>
      </div>
    </div>
  </body>
</template>
<script lang="ts" setup>
import LinkCss from '@/components/LinkCss.vue'
import type { BookItem } from '@/types/book_item'
import ProductImagesMobileCe from '@/components/product/mobile/ProductImagesMobile.ce.vue'
import ProductPrice from '@/components/product/ProductPrice.vue'
import tailwindCss from '@/styles/style.css?url'
import { getWithHost } from '@/utils/utils'
import ProductCharacteristicMobileCe from '@/components/product/mobile/ProductCharacteristicMobile.ce.vue'
import ProductButton from '@/components/product/ProductButton.vue'
import ProductSelect from '@/components/product_select/ProductSelect.vue'
import { ref } from 'vue'

const props = defineProps<{
  bookInfo: BookItem
}>()

const show = ref(false)

const emit = defineEmits<{
  (e: 'to-basket', v: BookItem): void
  (e: 'open-basket', v: BookItem): void
  (e: 'event:imageClicked', index: number): void
}>()
</script>
